var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.ConnexionFormComponent,{tag:"Component",on:{"toggle":function($event){_vm.isConnexionVisible = !_vm.isConnexionVisible},"close":_vm.closePanel}}),_c('RouterLink',{staticClass:"form__close button -close",attrs:{"to":_vm.closePanelLink,"aria-label":_vm.$t('app.ariaLabel.closeConnexion')}},[_c('Icon',{attrs:{"id":"close"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }